import React, { useEffect, useState } from "react";
import { keyEntry, project, projectGroup, translation } from "../../../system/types/project/project";
import { initialProject } from "../../../system/initial/project";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/reducers";
import { dispatch } from "../../../App";
import { actions } from "../../../redux";
import { TextInput } from "../../FormElements/TextInput";
import { formatKey } from "../../../system/helper/formatKey";
import { language } from "../../../system/types/project/language";
import { TextAreaInput } from "../../FormElements/TextareaInput";
import { ProjectApi } from "../../../system/api/ProjectApi";
import { useTranslations } from "../../../hooks/useTranslations";

const EditTranslation = () => {

    const { t } = useTranslations();

    const [sessionToken, setSessionToken] = useState<string>('');
    const [sessionEmail, setSessionEmail] = useState<string>('');
    const [projectData, setProjectData] = useState<project>(initialProject);

    const [projectId, setProjectId] = useState<string>('');
    const [commandId, setCommandId] = useState<string>('');
    const [commandGroup, setCommandGroup] = useState<string>('');
    const [allowDelete, setAllowDelete] = useState<boolean>(false);

    const [editGroup, setEditGroup] = useState<projectGroup>({
        uniqueId: '',
        key: '',
        name: '',
        description: '',
        groups: [],
        entries: [],
    });

    const [editTranslations, setEditTranslations] = useState<keyEntry>({
        uniqueId: '',
        key: '',
        name: '',
        translations: [],
    });

    const [editName, setEditName] = useState<string>('');
    const [editKey, setEditKey] = useState<string>('');

    const [languages, setLanguages] = useState<language[]>([]);
    const [translations, setTranslations] = useState<translation[]>([]);

    useSelector((state: RootState) => {

        if (state.activeUser.activeUserToken !== sessionToken) {
            setSessionToken(state.activeUser.activeUserToken);
        }

        if (state.activeUser.activeUserEmail !== sessionEmail) {
            setSessionEmail(state.activeUser.activeUserEmail);
        }

        if (state.project.projectId !== projectId) {
            setProjectId(state.project.projectId);
        }
        if (state.project.projectData !== projectData) {
            setProjectData(state.project.projectData);
        }
        if (state.project.pageCommandId !== commandId) {
            setCommandId(state.project.pageCommandId);
        }
        if (state.project.pageCommandSubSelect !== commandGroup) {
            setCommandGroup(state.project.pageCommandSubSelect);
        }

    });

    const save = async () => {

        const saveTranslation = {
            ...editTranslations,
            key: editKey,
            name: editName,
            translations: translations,
        };

        let entryFound:boolean = false;
        const newEntries:keyEntry[] = [];
        editGroup.entries.forEach((entry) => {
            if (entry.uniqueId === saveTranslation.uniqueId) {
                newEntries.push(saveTranslation);
                entryFound = true;
                return;
            }
            newEntries.push(entry);
        });

        if (!entryFound) {
            newEntries.push(saveTranslation);
        }

        const saveGroup = {
            ...editGroup,
            entries: newEntries,
        };

        const api = new ProjectApi(sessionToken, sessionEmail);

        const result = await api.saveGroupData(projectId, saveGroup);

        if (result._id) {
            dispatch(actions.project.setData(result))
            dispatch(actions.project.setPageCommand(''));
        }

    };

    const  deleteEntry = () => {

    };

    const cancel = () => {
        dispatch(actions.project.setPageCommand(''));
    };


    const changeEditName = (input: string) => {
        setEditName(input);
        if (commandId === '') {
            changeEditKey(input);
        }
    };

    const changeEditKey = (input: string) => {
        const formatedKey = formatKey(input);
        setEditKey(formatedKey);
    };

    const getTranslationValue = (isoCode: string): string => {

        let retValue = '';

        translations.forEach((translation) => {
            if (translation.isoCode === isoCode) {
                retValue = translation.text;
            }
        });

        return retValue;
    }

    const changeTranslationValue = (isoCode: string, input:string) => {
        let isoFound: boolean = false;
        const newTranslations: translation[] = [];

        translations.forEach((translation) => {
            if (translation.isoCode === isoCode) {
                newTranslations.push({
                    isoCode: isoCode,
                    text: input,
                });
                isoFound = true;
                return;
            }
            newTranslations.push(translation);
        });

        if (!isoFound) {
            newTranslations.push({
                isoCode: isoCode,
                text: input,
            });
        }
        setTranslations(newTranslations);
    }

    useEffect(() => {

        projectData.groups.forEach((group) => {
            if (group.uniqueId === commandGroup) {
                setEditGroup(group);
                return;
            }
        });

        const newLanguages: language[] = [];
        newLanguages.push(projectData.baseLanguage);

        projectData.languages.forEach((language) => {
            newLanguages.push(language);
        });

        setLanguages(newLanguages);

    }, [projectData, commandGroup]);

    useEffect(() => {

        editGroup.entries.forEach((entry) => {
            if (entry.uniqueId === commandId) {
                setEditTranslations(entry);
            }
        });

    }, [editGroup])

    useEffect(() => {
        setEditName(editTranslations.name);
        setEditKey(editTranslations.key);
        setTranslations(editTranslations.translations);
    },[editTranslations])

    return (
        <div className="container-float px-3 py-3">
            <div className="row mb-3 align-items-center">
                <div className="col">
                    <h2>{editGroup.name} - {editName} &nbsp;</h2>
                    {editGroup.key}.{editKey}
                </div>
                <div className="col-auto"><button onClick={save} className="btn btn-outline-success">{t('common.save')}</button></div>
                {allowDelete ?
                    <div className="col-auto"><button onClick={deleteEntry} className="btn btn-outline-danger">{t('common.delete')}</button></div>
                    : null}
                <div className="col-auto"><button onClick={cancel} className="btn btn-outline-danger">{t('common.cancel')}</button></div>
            </div>
            <div className="row mb-3">
                <div className="col">
                    <TextInput
                        name="translationName"
                        value={editName}
                        label={t('projects.translationname')}
                        onChange={changeEditName}></TextInput>
                </div>
            </div>
            {commandId === '' ?
                <div className="row mb-3">
                    <div className="col">
                        <TextInput
                            name="translationKey"
                            value={editKey}
                            label={t('projects.translationkey')}
                            onChange={changeEditKey}></TextInput>
                    </div>
                </div>
                :
                <div className="row mb-3">
                    <div className="col-3"><strong>{t('projects.translationkey')}:</strong></div>
                    <div className="col-auto">{editKey}</div>
                </div>
            }
            {
                languages.map((lanuguage) => (
                    <div className="row mb-3" key={lanuguage.isoCode}>
                        <div className="col">
                        <TextAreaInput
                        name="projectDescription"
                        value={getTranslationValue(lanuguage.isoCode)}
                        label={lanuguage.name}
                        lang={lanuguage.lang}
                        onChange={(newValue:string) => {
                            changeTranslationValue(lanuguage.isoCode, newValue)
                        }}></TextAreaInput>
                        </div>
                    </div>
                ))
            }

        </div>

    );
};

export { EditTranslation };